import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { TranslateService } from '@ngx-translate/core';
import { SessionService } from 'src/app/session-service.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-back-button',
  templateUrl: 'back-button.html',
  styleUrls: ['back-button.css'],
  encapsulation: ViewEncapsulation.None
})
export class BackButtonComponent {
  @Input()
  stepper: MatStepper;
  relativePath: string;
  @Input()
  disabled = false;

  constructor(
    translateService: TranslateService,
    sessionService: SessionService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    const {
      productType,
      locale,
    } = this.activatedRoute.snapshot.params;

    this.relativePath = locale ?
      `/${locale}/${productType}` :
      `/${productType}`;
  }

  isFirstStepperPage(): boolean {
    return this.stepper.selectedIndex === 0;
  }

  goBack(): void {
    if (this.disabled) {
      return;
    }
    if (this.isFirstStepperPage()) {
      this.router.navigate([this.relativePath]);
    } else {
      this.stepper.previous();
    }
  }
}
